import { render } from "./purchases.vue?vue&type=template&id=2300c741&scoped=true"
import script from "./purchases.vue?vue&type=script&lang=js"
export * from "./purchases.vue?vue&type=script&lang=js"

import "./purchases.vue?vue&type=style&index=0&id=2300c741&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2300c741"]])

export default __exports__